import { useDispatch } from "react-redux";
import CustomDropdown from "../../../components/components-library/dropdown";
import useMovePayment from "../../../hooks/trade_detail/useMovePayment";
import { setMoveComments, setMoveSelection } from "../../../reducers/trade_details_Slice";

const MovePayment: React.FC<{

}> = ({

}) => {

        const { selectingTradeId, moveSelection, moveComments } = useMovePayment();

        const dispatch = useDispatch();

        const handleSelect = (value: any) => {
            dispatch(setMoveSelection(value));
        };

        const tradeOptions = selectingTradeId?.map((item: any) => ({
            value: item.tradeId,
            label: (
                <div className="flex gap-14">
                    <span>Trade Id: {item.tradeId}</span>
                    <span>Trade Name: {item.tradeName}</span>
                </div>
            ),
        }));

        return (
            <>
                <CustomDropdown
                    label="Trade ID & Trade Name"
                    options={tradeOptions}
                    value={moveSelection}
                    onChange={handleSelect}
                    placeholder=""
                    className="flex-1"
                    required={true}
                />

                <div className="space_18">
                    <span className="fs-14">Comments<span className="color-red">*</span></span>
                    <textarea
                        className="h-[100px] w-[100%] p-2 border border-gray rounded-lg"
                        value={moveComments}
                        onChange={(e) => {
                            let value = e.target.value;
                            dispatch(setMoveComments(value));
                        }}
                    />
                </div>
            </>
        )
    }
export default MovePayment;